module.exports = __webpack_public_path__ + "static/media/ico-cm.3902c1e2.svg";